<template>
  <div>
    <span v-if="beforeMessage" :class="beforeMessageClass">
      {{ beforeMessage }}
    </span>
    <router-link
      target="_blank"
      :class="classComposant"
      :to="to" v-if="autorisation">
      <span :class="classMessage" v-if="!icon">{{ message }}</span>
      <b-icon :icon="icon" :type="typeIcon" v-else
              :size="sizeIcon"
              :custom-size="customSize"
              :class="classMessage"></b-icon>
      <slot></slot>
    </router-link>
    <router-link class="text-access-no-permission" :to="to" v-else>
      <span :class="classMessage" v-if="!icon">{{ message }}</span>
      <b-icon :icon="icon" :type="typeIcon" v-else
              :size="sizeIcon"
              :custom-size="customSize"
              :class="classMessage"></b-icon>
      <slot></slot>
    </router-link>
  </div>
</template>

<script>
import permissionRouterLink from '@/services/permission/permissionRouterLink';

export default {
  name: 'routerLinkBlank',
  data() {
    return {
      permission: '',
    };
  },
  props: {
    icon: {
      type: String,
      default: null,
      required: false,
    },
    customSize: {
      type: String,
      default: null,
      required: false,
    },
    typeIcon: {
      type: String,
      default: null,
      required: false,
    },
    sizeIcon: {
      type: String,
      default: null,
      required: false,
    },
    beforeMessage: String,
    to: Object,
    message: String,
    classMessage: String,
    beforeMessageClass: String,
    classComposant: {
      type: String,
      default: 'lien',
    },
  },
  computed: {
    autorisation() {
      return permissionRouterLink(this.to);
    },
  },
};
</script>
